import { useMemo } from 'react';

import type { CatalogItem } from '@/entities/catalog-item';
import { takeItemBasedOnOrder } from '@/entities/symbol';

export function useFilteredCatalogData(
  catalog: CatalogItem[] | undefined,
  expandedData: boolean,
  isForwardCurves: boolean
): CatalogItem[] {
  return useMemo(() => {
    if (!catalog) return [];
    if (expandedData || isForwardCurves) return catalog;

    return Object.values(
      catalog.reduce((acc: Partial<Record<string, CatalogItem>>, item) => {
        const existing = acc[item.Code];
        if (existing) {
          acc[item.Code] = takeItemBasedOnOrder(existing, item) as CatalogItem;
        } else {
          acc[item.Code] = item;
        }
        return acc;
      }, {})
    ).filter((item): item is CatalogItem => item !== undefined);
  }, [catalog, expandedData, isForwardCurves]);
}
